import styled from "styled-components";
import { rawColors } from "./colors/color";


type DividerProps = {
  color?: string;
};


export const Divider = styled.div<DividerProps>`
  height: 1px;
  background-color: ${props => props.color ? props.color : rawColors.gray.normal};
  margin:0;
  width:100%;
`;

